import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as FareRuleService from './../services/fareRuleService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseListRequestParamsCameo } from '../utils/commonUtils';
import {
    setListFareRules as setListFareRulesAction,
    setFareRuleDetail as setFareRuleDetailAction,
} from './../actions/fareRuleAction';
import history from './../helpers/history';

function* getListFareRules() {
    yield takeLatest(Types.FARE_RULE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.filters || {});
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(FareRuleService.getFareRule, params);
        yield put(setListFareRulesAction(result));
    }, errorHandleFareRule(Types.FARE_RULE_LIST_FAIL)))
}

function* getFareRuleDetail() {
    yield takeLatest(Types.FARE_RULE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(FareRuleService.getFareRuleDetail, action.id);
        yield put(setFareRuleDetailAction(result));
    }, errorHandleFareRule(Types.FARE_RULE_DETAIL_FAIL)))
}

function* updateFareRuleDetail() {
    yield takeLatest(Types.FARE_RULE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(FareRuleService.updateFareRuleDetail, action.fareRule.fareRule);
        successHandleFareRule(action, action.fareRule.fareRule.className);
        yield put(setFareRuleDetailAction(action.fareRule.fareRule));
        history.push(PATHS.FARE_RULES.LIST.path);
        history.go();
    }, errorHandleFareRule(Types.FARE_RULE_DETAIL_FAIL)))
}

function* createFareRuleDetail() {
    yield takeLatest(Types.FARE_RULE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(FareRuleService.createFareRuleDetail, action.fareRule);
        successHandleFareRule(action, action.fareRule.className);
        yield put(setFareRuleDetailAction(action.fareRule));
        history.push(PATHS.FARE_RULES.LIST.path);
        history.go();
    }, errorHandleFareRule(Types.FARE_RULE_DETAIL_FAIL)))
}

function* deleteFareRuleDetail() {
    yield takeLatest(Types.FARE_RULE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(FareRuleService.deleteFareRuleDetail, action.fareRule);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseListRequestParamsCameo(action.filter || {});
        const resultList = yield call(FareRuleService.getFareRule, params);
        yield put(setListFareRulesAction(resultList));
    }, errorHandleFareRule(Types.FARE_RULE_DETAIL_FAIL)));
}


/* Transtale Saga */

function* createFareRuleTranslate() {
    yield takeLatest(Types.FARE_RULE_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(FareRuleService.createFareRuleTranslate, action.fareRule);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.fareRule.translate.languageName);
        yield put({ type: Types.FARE_RULE_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.FARE_RULE_DETAIL_ACTION, id: action.fareRule.id });
    }, errorHandleFareRule(Types.FARE_RULE_FAIL)))
}

function* updateFareRuleTranslate() {
    yield takeLatest(Types.FARE_RULE_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(FareRuleService.updateFareRuleTranslate, action.fareRule);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.fareRule.translate.languageName);
        yield put({ type: Types.FARE_RULE_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.FARE_RULE_DETAIL_ACTION, id: action.fareRule.id });
    }, errorHandleFareRule(Types.FARE_RULE_FAIL)))
}

function* deleteFareRuleTranslate() {
    yield takeLatest(Types.FARE_RULE_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(FareRuleService.deleteFareRuleTranslate, action.fareRule.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.fareRule.translate.languageName);
        yield put({ type: Types.FARE_RULE_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.FARE_RULE_DETAIL_ACTION, id: action.fareRule.id });
    }, errorHandleFareRule(Types.FARE_RULE_FAIL)))
}

function successHandleFareRule(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.fareRule.title')} "${value}"`
    })
}


function errorHandleFareRule(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'fareRule');
}

export function* fareRuleSaga() {
    yield all([
        fork(getListFareRules),
        fork(getFareRuleDetail),
        fork(updateFareRuleDetail),
        fork(createFareRuleDetail),
        fork(createFareRuleTranslate),
        fork(updateFareRuleTranslate),
        fork(deleteFareRuleDetail),
        fork(deleteFareRuleTranslate)
    ])
}
